import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'upsc-cre-autoclosure-dispute',
  templateUrl: './cre-autoclosure-dispute.component.html',
  styleUrls: ['./cre-autoclosure-dispute.component.scss']
})



export class CreAutoclosureDisputeComponent {

  @Input() claimNumber = '';
  submitMoreDetails: boolean = false;
  @Output() submittedInfoMoreEvent = new EventEmitter<boolean>(false);

  constructor() { }


  ngOnInit() {

  }

  submitMoreInfo() {
    if (this.submitMoreDetails)
      this.submitMoreDetails = false;
    else
      this.submitMoreDetails = true;
  }

  openInNewTab(url: string): void {
    window.open(url, '_blank');
  }

  submittedInfoMore($event: boolean) {
    this.submittedInfoMoreEvent.emit($event);
  }

}
